import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import "./css/ColumnDetails.css"
import MyBarChart from "../../../Charts/MyBarChart"
import LineBarChart from "../../../Charts/LineBarChart"


function getDataForHistogram(column_data){
        var max = column_data[column_data.length - 1]
        var min = column_data[0]
        var hist_data = []
        var hist_range = []
        var diff = max - min
        for (var i = 10; i <= 100; i += 10) {
                hist_range.push(min + ((diff * i) / 100))
        }
        var hist_range_index = 0
        var freq = 0
        for (var j in column_data) {
                if (column_data[j] <= hist_range[hist_range_index]) {
                        freq += 1
                }
                else {
                        var label = (Math.round(hist_range[hist_range_index - 1]) || Math.round(column_data[0])) + " to " + Math.round(hist_range[hist_range_index])
                        hist_data.push({ name: hist_range_index, count: freq, range: label })
                        freq = 0
                        hist_range_index += 1
                }
        }
        return hist_data
}


export default function ColumnDetails(props) {
        const [selectedColumn, setSelectedColumn] = React.useState()
        const [columnNames, setColumnNames] = React.useState()
        const [columnsDetails, setColumnDetails] = React.useState()

        React.useEffect(() => {
                setSelectedColumn(props.columns[0])
                setColumnNames(props.columns)
                setColumnDetails(props.details)
        }, [setSelectedColumn, setColumnDetails, setColumnNames, props])

        function LeftContainerCategoricalOrContinuous(type){
                if (type==="continuous"){
                        return (
                                <React.Fragment>
                                        <div className="d-flex">
                                                <p className="p-0 m-0" style={{ fontSize: "23px", color: "grey", textTransform: "capitalize", whiteSpace: "nowrap" }}>{type} Feature</p>
                                                <label className="text-primary ml-1" style={{ fontSize: "13px" }}>predicted</label>
                                        </div>
                                        <div className="mt-2 font-weight-bold">
                                                <p className="m-0 p-0">Surety Percentage: {columnsDetails[selectedColumn]["surety"]}%</p>
                                                <p className="m-0 p-0">Data Type: {columnsDetails[selectedColumn]["data_type"]}</p>
                                                <p className="m-0 p-0">This feature contains {columnsDetails[selectedColumn]["null_values_count"]} null values</p>
                                        </div>
                                        <hr className="bg-primary" style={{ height: "3px" }}></hr>
                                        <button className="btn btn-primary" >Change to Categorical</button>
                                </React.Fragment>
                        )
                }
                else{
                        return (
                                <React.Fragment>
                                <div className="d-flex">
                                        <p className="p-0 m-0" style={{ fontSize: "23px", color: "grey", textTransform: "capitalize", whiteSpace: "nowrap" }}>{type} Feature</p>
                                        <label className="text-primary ml-1" style={{ fontSize: "13px" }}>predicted</label>
                                </div>
                                <div className="mt-2 font-weight-bold">
                                        <p className="m-0 p-0">This feature is categorical with {columnsDetails[selectedColumn]["unique_values_count"]} unique values</p>
                                        <p className="m-0 p-0">Surety Percentage: {columnsDetails[selectedColumn]["surety"]}%</p>
                                        <p className="m-0 p-0">Data Type: {columnsDetails[selectedColumn]["data_type"]}</p>
                                </div>
                                <hr className="bg-primary" style={{ height: "3px" }}></hr>
                                <button className="btn btn-primary" >Change to Continuous</button>
                                </React.Fragment>
                        )
                }
        }       

        function RightContainerCategoricalOrContinuous(type){
                if (type === "continuous") {
                        var dtype = columnsDetails[selectedColumn]["data_type"]
                        if (dtype === "int64" || dtype === "float64" || dtype === "int32" || dtype === "float32" )
                        {
                                var column_data = columnsDetails[selectedColumn]["data"]
                                var hist_data = getDataForHistogram(column_data)
                                return (
                                        <React.Fragment>
                                                <LineBarChart data={hist_data}/>
                                                <div className="w-100" align="center">
                                                        <p className="font-weight-bold">{selectedColumn} Distribution</p>
                                                </div>
                                        </ React.Fragment>
                                )
                        }
                        else{
                                return (
                                        <div className="w-100 mt-5" align="center">
                                                <h3>This Column is continuous and contains object type data</h3>
                                                <h5>It is droppable column according to our algorithm</h5>
                                                <button className="btn btn-primary">See the column</button>
                                        </div>
                                )
                        }
                }
                else{
                        var data = []
                        for (var key in columnsDetails[selectedColumn]["categories"]){
                                data.push({name: key, count: columnsDetails[selectedColumn]["categories"][key]})
                        }
                        return (
                                <MyBarChart data={data}/>
                        )
                }
        }

        return (
                <div className="container-fluid mt-4 p-2" >
                        {columnsDetails ?
                                <Row>
                                        <Col lg={4} md={12}>
                                                <select className="custom-select" onChange={(e) => { setSelectedColumn(e.target.value) }}>
                                                        {columnNames.map((key) => {
                                                                return <option key={key} value={columnNames[key]}>{key}</option>
                                                        })}
                                                </select>
                                                <Container fluid className="mt-3 py-2 container-shadow" style={{ height: "300px", backgroundColor: "white" }}>
                                                        <h3 className="font-weight-bold">{selectedColumn}</h3>
                                                        <hr className="bg-primary" style={{height: "3px"}}></hr>
                                                        {LeftContainerCategoricalOrContinuous(columnsDetails[selectedColumn]["type"])}
                                                </Container>
                                        </Col>
                                        <Col lg={8} md={12}>
                                                <Container fluid className="container-shadow bar-chart-container scrollbar_property" style={{ minHeight: "370px", backgroundColor: "white" }}>
                                                        {RightContainerCategoricalOrContinuous(columnsDetails[selectedColumn]["type"])}
                                                </Container>
                                        </Col>
                                </Row>
                                :
                                null
                        }
                </div>
        )
}
